import styled from "styled-components";

import TextBase from "components/common/Text";

export const Value = styled(TextBase)`
  color: ${({ theme }) => theme.masterColors.mediumGrey};
  cursor: default;
`;
